import { secondaryPackagingRequest } from '@/request'

//获取短信配置信息
export const smsInfo = params => secondaryPackagingRequest({
    url: '/sys/sms/info',
    params,
    isLoading: false,
    needToken: true
})
//保存短信配置信息
export const smsInfoSave = data => secondaryPackagingRequest({
    url: '/sys/sms/save',
    method: 'POST',
    headers: {
        'Content-Type': 'application/json'
    },
    data,
    isLoading: false,
    needToken: true,
})
//获取账号对应的手机号
export const userSensitiveInfo = params => secondaryPackagingRequest({
    url: '/common/userSensitiveInfo',
    params,
    isLoading: false,
    needToken: false
})
//获取短信验证码
export const sendVerifyCode = params => secondaryPackagingRequest({
    url: '/common/sendVerifyCode',
    params,
    isLoading: false,
    needToken: false
})
//找回密码
export const tofindPassword = data => secondaryPackagingRequest({
    url: '/common/findPassword',
    method: 'POST',
    headers: {
        'Content-Type': 'application/json'
    },
    data,
    isLoading: false,
    needToken: true,
})



//注册
export const userRegister = data => secondaryPackagingRequest({
    url: '/sys/user/register',
    method: 'POST',
    headers: {
        'Content-Type': 'application/json'
    },
    data,
    isLoading: true,
	needTips: false,
    needToken: false,
    loadingText: '注册中...'
})
//注册(验证码)
export const registerByCode = data => secondaryPackagingRequest({
    url: '/sys/user/registerByCode',
    method: 'POST',
    headers: {
        'Content-Type': 'application/json'
    },
    data,
    isLoading: true,
	needTips: false,
    needToken: false,
    loadingText: '注册中...'
})
//修改用户
export const userUpdate = data => secondaryPackagingRequest({
    url: '/sys/user/update',
    method: 'POST',
    headers: {
        'Content-Type': 'application/json'
    },
    data,
    isLoading: false,
    needToken: true
})
//删除用户
export const userDelete = params => secondaryPackagingRequest({
    url: '/sys/user/delete',
    method: 'POST',
    params,
    isLoading: false,
    needToken: true
})
//修改个人资料（用户头像）
export const updateAvatar = data => secondaryPackagingRequest({
    url: '/sys/user/updateAvatar',
    method: 'POST',
    headers: {
        'Content-Type': 'multipart/form-data'
    },
    data,
    isLoading: false,
    needToken: true
})
//修改密码
export const updatePassword = data => secondaryPackagingRequest({
    url: '/sys/user/updatePassword',
    method: 'POST',
    headers: {
        'Content-Type': 'application/json'
    },
    data,
    isLoading: false,
    needToken: true
})
//修改用户角色
export const updateUserRole = data => secondaryPackagingRequest({
    url: '/sys/user/updateUserRole',
    method: 'POST',
    headers: {
        'Content-Type': 'application/json'
    },
    data,
    isLoading: false,
    needToken: true
})
//修改角色定位信息
export const updateUserPosition = data => secondaryPackagingRequest({
    url: '/sys/user/position',
    method: 'POST',
    headers: {
        'Content-Type': 'application/json'
    },
    data,
    isLoading: false,
    needToken: true
})
